export default __webpack_public_path__ + "static/media/datapower-routing.73657f92.svg";